function queryParamsFunction(baseURL, api, queryParams) {

    const url = new URL(api, baseURL);

    Object.keys(queryParams).forEach(key => {
        if (queryParams[key] !== undefined && queryParams[key] !== null) {
            url.searchParams.append(key, queryParams[key]);
        }
    });

    return url.toString();
}

export { queryParamsFunction };
